import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Swal from "sweetalert2";
import axios from "axios";
import IMask from "imask";

@Component
export default class ContactForm extends Vue {
  $refs!: {
    form: HTMLFormElement;
    content: HTMLElement;
  };

  mounted() {
    let telephone = this.$refs.form.querySelector<HTMLInputElement>(
      "input[name='telephone']"
    );
    if (telephone !== null) {
      IMask(telephone, {
        mask: "+{38\\0}(00)00-00-000"
      });
    }
  }

  formSended() {}

  /**  Отпавляет форму заказа звонка*/
  sendForm() {
    if (this.$refs.form.checkValidity()) {
      let formNameField = this.$refs.form.querySelector<HTMLInputElement>(
        "input[name='formName']"
      );
      let telephone = this.$refs.form.querySelector<HTMLInputElement>(
        "input[name='telephone']"
      );
      let name = this.$refs.form.querySelector<HTMLInputElement>(
        "input[name='name']"
      );

      this.$refs.content.style.opacity = "0.5";
      this.$refs.content.style.pointerEvents = "none";

      axios
        .post("/api/contactForms/send", {
          screen: localStorage.getItem("screen") || "",
          telephone: telephone!.value,
          name: name !== null ? name.value : "",
          formName: formNameField !== null ? formNameField.value : ""
        })
        .then(response => {
          this.$router.push("/thank-you");
          Swal.fire({
            type: "success",
            title: "Спасибо!",
            html:
              '<div class="thank-text"><span>Ваша заявка принята!</span> Спасибо, что обратились в компанию DomExpert!</div>',
            onClose: () => {
              this.$router.push("/");
            }
          });

          this.$refs.content.style.opacity = "1";
          this.$refs.content.style.pointerEvents = "all";
        })
        .catch(error => {
          this.error();
        });
    } else {
      this.$refs.form.reportValidity();
    }
  }

  error() {
    Swal.fire({
      type: "error",
      title: "Упс...",
      text: "Произошла ошибка. Попробуйте еще раз позже."
    });

    this.$refs.content.style.opacity = "1";
    this.$refs.content.style.pointerEvents = "all";
  }
}
